import { Component, AfterViewInit, OnInit, NgZone, ViewChild, ChangeDetectorRef, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import { TdLoadingService, TdMediaService, TdDialogService, } from '@covalent/core';

import { TecnicaTerapeutica } from '../../../../../models/';

import { MasterService, LoginService, TecnicasTerapeuticasService, } from '../../../../../services/';

@Component({
  selector: 'qs-altatecnicaterapeutica',
  templateUrl: './altatecnicaterapeutica.component.html',
  viewProviders: [MasterService, TecnicasTerapeuticasService, ],
})

export class AltaTecnicaTerapeuticaComponent implements AfterViewInit, AfterViewChecked {

  public tecnica: any;
  public titulo: string;
  public tecnicaForm: NgForm;
  public idPaciente: string;
  public viaAdministracion: string;
  public cantidad: string;
  public disabled: boolean = false;
  public invert: boolean = false;
  public max: number = 10;
  public min: number = 0;
  public showTicks: boolean = true;
  public step: number = 0.5;
  public thumbLabel: boolean = true;
  public tickInterval: number = 0.5;
  public indicado: boolean;
  public realizado: boolean;
  public texto: string;
  public indicadoEnabled: boolean;
  public realizadoEnabled: boolean;
  public viaAdministracionEnabled: boolean;
  public cantidadEnabled: boolean;
  public mode: string;
  public observIndicacion: string;
  public observRealizacion: string;
  public valoraciones: any[];
  public idValoracion: string;

  public vias: any = [];

  constructor(private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _masterService: MasterService,
    private _tecnicasTerapeuticasService: TecnicasTerapeuticasService,
    private _loginService: LoginService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _dialogService: TdDialogService,
    private _changeDetectorRef: ChangeDetectorRef, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('altatecnicaterapeutica.load');
    let tecnicaId: string = this.tecnica.idTecnica !== undefined ? this.tecnica.idTecnica : this.tecnica.id;
    this._masterService.obtenerMasterViasAdministración(tecnicaId).subscribe((res: any) => {
      this.vias = res.respuesta.vias;
      this._loadingService.resolve('altatecnicaterapeutica.load');
      if (this.mode === 'edit') {
        this.texto = this.tecnica.texto !== undefined ? this.tecnica.texto[0] : '';
        this.observIndicacion = this.tecnica.observIndicacion !== undefined ? this.tecnica.observIndicacion[0] : '';
        this.observRealizacion = this.tecnica.observRealizacion !== undefined ? this.tecnica.observRealizacion[0] : '';
        this.indicado = this.tecnica.fechaIndicacion !== '' ? true : false;
        this.indicadoEnabled = this.tecnica.fechaIndicacion !== '' ? true : false;
        this.realizado = this.tecnica.fechaRealizacion !== '' ? true : false;
        this.realizadoEnabled = this.tecnica.fechaRealizacion !== '' ? true : false;
        this.titulo = this.tecnica.mtecnica !== undefined ? this.tecnica.mtecnica[0] : '';
        this.viaAdministracion = this.tecnica.viaAdministracion !== undefined ? this.tecnica.viaAdministracion[0] : '';
        this.viaAdministracionEnabled = this.tecnica.viaAdministracion !== undefined ? true : false;
        this.cantidad = this.tecnica.cantidad !== undefined ? this.tecnica.cantidad[0] : 0;
        this.cantidadEnabled = this.tecnica.cantidad !== undefined ? true : false;
      } else {
        this.mode = 'add';
      }
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo vias de administración.', 'OK', 6000);
      this._loadingService.resolve('altatecnicaterapeutica.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  /**
   * FIX: Esto es un fix para ExpressionChangedAfterItHasBeenCheckedError
   * Aparece al cargar un componente de la vista con datos desde un servicio
   */
  ngAfterViewChecked(): void {
    this._changeDetectorRef.detectChanges();
  }

  delete(form: NgForm): void {
    this.mode = 'del';
    this.save(form);
  }

  save(form: NgForm): void {

    this._loadingService.register();
    this.valoraciones = this._loginService.transient || '';

    // Tiene valoraciones previas
    let valoracionId: number = -1;
    if (this.idValoracion !== undefined && this.idValoracion !== 'undefined') {
      valoracionId = +this.idValoracion;
    }

    let fecha: Date = new Date();
    let fechaTexto: string = fecha.getDate() + '/' + (fecha.getMonth() + 1) + '/' + fecha.getFullYear();

    let params: any = {
      accion: '',
      vteID: valoracionId,
      vteNumexp: this._loginService.consulta.numeroExpediente,
      vteFecha: fechaTexto,
      vteNumVisita: this._loginService.consulta.visita,
      vteDniMed: this._loginService.profesional.Dni,
      tteID: '',
      tteIdTecnica: '',
      tteTextoLibre: this.texto,
      tteViaAdministracion: this.viaAdministracion,
      tteCantidad: this.cantidad,
      tteFechaIndicacion: this.indicado ? fechaTexto : '',
      tteFechaRealizacion: this.realizado ? fechaTexto : '',
      tteDniMedIndicacion: this.indicado ? this._loginService.profesional.Dni : '',
      tteDniMedRealizacion: this.realizado ? this._loginService.profesional.Dni : '',
      tteNumVisitaIndicacion: this.indicado ? this._loginService.consulta.visita : '',
      tteNumVisitaRealizacion: this.realizado ? this._loginService.consulta.visita : '',
      tteMotivoBorrado: '',
      tteDniBorrado: '',
      tteObservIndicacion: this.observIndicacion !== undefined ? this.observIndicacion : '',
      tteObservRealizacion: this.observRealizacion !== undefined ? this.observRealizacion : '',
    };
    switch (this.mode) {
      case 'edit':
        params.accion = 'M';
        params.tteID = this.tecnica.id[0];
        params.tteIdTecnica = this.tecnica.idTecnica[0];
        break;
      case 'add':
        params.tteIdTecnica = this.tecnica.id;
        params.accion = 'I';
        break;
      case 'del':
        params.accion = 'B';
        params.tteMotivoBorrado = 'HCIONCLOUD';
        params.tteDniBorrado = this._loginService.profesional.Dni;
        params.tteIdTecnica = this.tecnica.idTecnica[0];
        params.tteID = this.tecnica.id[0];
        break;
      default: break;
    }
    this._tecnicasTerapeuticasService.guardarTecnicaTerapeutica(params).subscribe((res: any) => {
      if (res) {
        this._loginService.mostrarMensaje('Técnicas Diagnóstica Añadida', 'OK', 6000);
        this.close();
        this._loadingService.resolve();
        this._router.navigate(['/main/consulta/', this._loginService.consulta.numeroExpediente, 'tecnicasterapeuticas']);
      } else {
        this._loginService.mostrarMensaje('Error al insertar Técnica Terapéutica', 'OK', 6000);
        this._loadingService.resolve();
      }
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error procesando el alta', 'OK', 6000);
      this._loadingService.resolve();
    });
  }

  close(): void {
    this._dialogService.closeAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/tecnicasterapeuticas/tecnicasterapeuticasdetalle/altatecnicaterapeutica/altatecnicaterapeutica.component.ts